import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export enum AgentTaskStatus {
  TODO = "todo",
  IN_PROGRESS = "in-progress",
  BLOCKED = "blocked",
  COMPLETE = "complete",
  CANCELED = "canceled",
}

export enum AgentTaskAssigneeKind {
  USER = "user",
}

const agentTaskAssigneeSchema_ = z.object({
  kind: createEnum(AgentTaskAssigneeKind, {
    enumName: "agent_task_assignee_kind",
  }),
  userId: z.string(),
});
export const AgentTaskAssigneeSchema: z.ZodType<AgentTaskAssignee> =
  agentTaskAssigneeSchema_;
export interface AgentTaskAssignee
  extends z.infer<typeof agentTaskAssigneeSchema_> {}

const agentTaskDefinitionRefSchema_ = z.object({
  id: z.string(),
  version: z.string(),
});
export const AgentTaskDefinitionRefSchema: z.ZodType<AgentTaskDefinitionRef> =
  agentTaskDefinitionRefSchema_;
export interface AgentTaskDefinitionRef
  extends z.infer<typeof agentTaskDefinitionRefSchema_> {}

const agentTaskSchema_ = z.object({
  _id: zExt.objectId(),
  taskDefinition: agentTaskDefinitionRefSchema_,
  description: z.string(),
  status: createEnum(AgentTaskStatus, { enumName: "agent_task_status" }),
  labels: z.array(z.string()),
  assignee: agentTaskAssigneeSchema_.optional(),
  teamId: z.string().optional(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const AgentTaskSchema: z.ZodType<AgentTask> = agentTaskSchema_;
export interface AgentTask extends z.infer<typeof agentTaskSchema_> {}
